import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import home from '../views/home'
import ceshi from '../views/ceshi'
import Login from '../views/login'

import { lsdRegionEcommerceStatIndex } from '@/api/home'
import { clearAllCookies } from '@/utils/tools'



Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'home',
    component: home,
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/ceshi',
    name: 'ceshi',
    component: ceshi
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach(async (to, from, next) => {
  try {
    // const res = await lsdRegionEcommerceStatIndex({})
    const code = sessionStorage.getItem('code')
    if (code == 200 ) {
      // cookie 有效
      if (to.path === '/login') {
        next('/') // 访问登录页但已登录，跳首页
      } else {
        next() // 访问其他页面且已登录，放行
      }
    } else {
      // cookie 无效
      await clearAllCookies()
      if (to.path !== '/login') {
        next('/login') // 跳转到登录页
      } else {
        next() // 已在登录页
      }
    }
  } catch (err) {
    await clearAllCookies()
    if (to.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  }
})

export default router

